<!-- 图片链接列表：用户信息展示 -->
<template>
<div class="info-block">
  <a href="#" class="info-block-a">
    <div class="div-1">
      <div class="div-1-1" v-bind:style="{backgroundImage:'url('+info.photo+')'}"></div>
      <div class="div-1-2">{{info.user_name}}</div>
      <div class="div-1-3">产地合作社</div>
      <div class="div-1-4">实名认证</div>
      <div class="div-1-5"><a href="#" class="link-view">报价寻价</a></div>
    </div>
  </a>
</div>
</template>
<script>
export default {
  name: 'InfoBlock13',
  props: {
    info: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {

    }
  },
  created:function(){

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info-block .info-block-a{
  display: block;
  box-sizing:border-box;
  height:340px;
  padding:0px;
  margin:0px 0px 10px 0px;
  //background-color:red;
  border:0px solid #ddd;
  //box-shadow: #bbb 0px 0px 10px;
}

.info-block .info-block-a:hover > .div-1{
  //border:1px solid var(--color6);
  //box-shadow:0px 0px 1px 0px var(--color6);
}

.div-1{
  position:relative;
  height:340px;
  width:100%;
  padding:0px 0px 0px 0px;
  //background:var(--color6);
  color:#fff;
  border:1px solid #ddd;
  background-size: auto 150px;
  background-repeat: no-repeat;
  background-position: center 0;
}

.div-1-1{
  position:relative;
  height:140px;
  width:140px;
  margin:10px auto;
  padding:10px;
  background:#eee;
  color:#fff;
  border:0px solid #ddd;
  border-radius:70px;
  background-size: auto 150px;
  background-repeat: no-repeat;
  background-position: center center;
}

.div-1-2{
  height:40px;
  padding:5px;
  font-size:14px;
  font-weight:600;
  text-align:center;
  color:#000;
}

.div-1-3{
  height:20px;
  padding:5px;
  font-size:12px;
  color:#888888;
  text-align:center;
  line-height:20px;
  //background:yellow;
}

.div-1-4{
  height:20px;
  padding:5px;
  font-size:12px;
  color:#888888;
  text-align:center;
  line-height:20px;
  //background:red;
}

.div-1-5{
  height:40px;
  padding:5px;
  font-size:12px;
  color:#888888;
  text-align:center;
  line-height:20px;
  //background:red;
}

.link-view{
  display:block;
  height:30px;
  width:100px;
  padding:5px 15px 5px 15px;
  margin:20px auto;
  border:1px solid var(--color7);
  background:var(--color7);
  color:#fff;
  line-height:20px;
  text-align:center;
}

.link-view:hover{
  border:1px solid var(--color6);
  background:var(--color6);
  color:#fff;
}
</style>



// WEBPACK FOOTER //
// src/components/block/InfoBlock13.vue